import { render } from "./GoogleCirclesCommunities.vue?vue&type=template&id=164c14d9"
import script from "./GoogleCirclesCommunities.vue?vue&type=script&lang=js"
export * from "./GoogleCirclesCommunities.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__